<!--
ToastContainer - Container per notifiche toast
Per Gleem Core
-->

<script setup lang="ts">
import { useToast } from '@/core/composables/useToast'

const { toasts, remove } = useToast()
</script>

<template>
  <div 
    class="fixed top-4 right-4 z-50 space-y-2 pointer-events-none"
    aria-live="polite"
    aria-atomic="true"
  >
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="pointer-events-auto toast"
        :class="`toast-${toast.type}`"
        role="alert"
      >
        <div class="flex items-center gap-3">
          <div class="flex-1">
            <p class="text-sm font-medium">{{ toast.message }}</p>
          </div>
          <button
            @click="remove(toast.id)"
            class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast {
  @apply min-w-[300px] max-w-md px-4 py-3 rounded-lg shadow-lg;
  @apply bg-white dark:bg-slate-800 border;
}

.toast-success {
  @apply border-green-500 bg-green-50 dark:bg-green-900/20;
}

.toast-error {
  @apply border-red-500 bg-red-50 dark:bg-red-900/20;
}

.toast-warning {
  @apply border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20;
}

.toast-info {
  @apply border-blue-500 bg-blue-50 dark:bg-blue-900/20;
}

/* Transitions */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>




